/**
 * Websites the n8n workflow can route to an Apify actor. Mirror of
 * backend/src/config/scrapable-hosts.config.ts — keep both in sync.
 * Matching is a substring test on project.website.
 */
export const SCRAPABLE_HOSTS: readonly string[] = [
  'remax.pt',
  'portadafrente.com',
  'castelhana.pt',
  'residential.jll.pt',
  'dils.pt',
  'lisbonpremiumproperty.com',
  'sothebysrealtypt.com',
  'immopo.com',
  'replica.pt',
  'luximos.pt',
  'residencial.savills.pt',
  'savills.pt',
  'idealista.pt',
  'quintelaepenalva.pt',
  'vizta.pt',
  'irglux.com',
  'essiarealestate.com',
  'piquet.pt',
  'realfolio.pt',
  'century21.pt',
  'vogue-homes.com',
]

export const isScrapableWebsite = (website: string | null | undefined): boolean =>
  !!website && SCRAPABLE_HOSTS.some((host) => website.includes(host))
